import { getDominantColor } from '@catalogit/common/lib/utils/media-utils.js';
import { type MediaResponseType } from '@catalogit/common/lib/types/media.js';

import type { IAccount } from '../types/store.js';

export const getBackgroundColor = (account: IAccount, imageRef: MediaResponseType): string => {
  return account.theme?.backgroundColor || getDominantColor(imageRef);
};
